<template>
  <v-alert
    class="my-1"
    :type="messageType ?? 'warning'"
    dense
    outlined
    border="left"
    :dismissible="dismissible ?? false"
    >{{ messageText }}</v-alert
  >
</template>

<script>
export default {
  props: ["messageType", "messageText", "dismissible"],
};
</script>
